import React from 'react';
import './style.css';

const Footer = () => {
  return (
    <footer>
      <span className="spanfooter">
        Feito Por <a href="https://github.com/vitorvf/">Vitor Ferreira</a>
      </span>
    </footer>
  );
};

export default Footer;
